import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  TextField,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { SnackbarProvider } from "notistack";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginButton from "./products/authentication/login.jsx";
import SignUpButton from "./products/authentication/signup.jsx";
import BarCodeIcon from "./products/barcode.png";
import delmonteLogo from "./products/delmonte.svg";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [isExternalOrigin, setIsExternalOrigin] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const allowedRoutes = ["/", "/products", "/products/"];
  const theme = useTheme();

  // Breakpoints for external header logo
  const breakpoint1 = useMediaQuery(theme.breakpoints.down(601));
  const breakpoint2 = useMediaQuery(theme.breakpoints.down(481));
  const breakpoint3 = useMediaQuery(theme.breakpoints.down(320));

  useEffect(() => {
    const referrer = document.referrer;
    const externalDomains = ["https://develop-delmonte.dird393khuadt.amplifyapp.com"];
    if (externalDomains.some((domain) => referrer.startsWith(domain))) {
      setIsExternalOrigin(true);
    }
  }, []);

  const getDimensions = () => {
    if (breakpoint3) return { width: 120, height: 35 };
    if (breakpoint2) return { width: 140, height: 41 };
    if (breakpoint1) return { width: 160, height: 47 };
    return { width: 110, height: 63 };
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    if ((e.key === "Enter" || e.type === "click") && search.trim() !== "") {
      navigate(`/products/details/${search.trim()}`);
      setSearch("");
    }
  };

  const shouldShowButtons = !isMobile || allowedRoutes.includes(location.pathname);

  if (isExternalOrigin) {
    return (
      <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',            
        top: 0,
        left: 0,
        width: '100%',
        height: '80px',         
        padding: '10px 30px',
        background: '#055527',
        zIndex: 1000,

        [theme.breakpoints.down('md')]: {
          padding: '15px 10px',
          marginLeft: '-30px',
        },
      })}
    >
      <a href="/">
        <img
          src={delmonteLogo}
          alt="logo"
          width={getDimensions().width}
          height={getDimensions().height}
        />
      </a>
    </Box>

    );
  }
  
  
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "80px",
          padding: "0 20px",
          backgroundImage: "linear-gradient(90deg, #144490, #124B98, #1154A3, #0C5FAD, #086CBA)",
          color: "white",
          zIndex: 1000,
          transition: "height 0.3s ease-in-out",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            cursor: "pointer",
          }}
          onClick={() => navigate("/products")}
        >
          <img
            src="/logo.svg"
            alt="Nova Logo"
            style={{
              height: "60px",
              maxWidth: "130px",
              objectFit: "contain",
            }}
          />
        </Box>

        {(location.pathname !== "/products" &&
          location.pathname !== "/products/" &&
          location.pathname !== "/" &&
          location.pathname !== "/products/search") && (
          <TextField
            value={search}
            onChange={handleSearchChange}
            onKeyDown={handleSearchSubmit}
            variant="outlined"
            placeholder="Search products..."
            sx={{
              width: { xs: "50%", sm: "40%", md: "30%" },
              borderRadius: "50px",
              backgroundColor: "white",
              "& .MuiOutlinedInput-root": {
                padding: "5px",
                borderRadius: "50px",
                "& fieldset": {
                  borderRadius: "50px",
                },
              },
            }}
            InputProps={{
              endAdornment: (
                <Box sx={{ display: "flex", gap: "10px" }}>
                  <IconButton onClick={handleSearchSubmit}>
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => navigate("/scannerTest")}
                    sx={{ width: "40px", height: "40px", paddingRight: "30px" }}
                  >
                    <img
                      src={BarCodeIcon}
                      alt="Barcode Icon"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "inline-block";
                      }}
                    />
                  </IconButton>
                </Box>
              ),
              inputProps: {
                style: { fontSize: "0.9rem", padding: "8px 12px" },
              },
            }}
          />
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          {shouldShowButtons && (
            <>
              <LoginButton />
              <SignUpButton />
            </>
          )}
        </Box>
      </Box>
    </SnackbarProvider>
  );
};

export default Header;
